// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contacts_error__uR0hl {
  margin: auto;
}

.Contacts_legalterms__9WM03 {
  font-size: 12px;
  line-height: 20px;
  margin-top: 12px;
}
.Contacts_legalterms__9WM03 span {
  display: inline;
  font-size: inherit;
  line-height: inherit;
  text-decoration: underline;
}

.Contacts_button__VgYjp {
  width: 174px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/RCPro/pages/Contacts/Contacts.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AACJ;AACI;EACI,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;AACR;;AAGA;EACI,uBAAA;AAAJ","sourcesContent":[".error{\n    margin: auto;\n}\n\n.legalterms{\n    font-size: 12px;\n    line-height: 20px;\n    margin-top: 12px;\n\n    span{\n        display: inline;\n        font-size: inherit;\n        line-height: inherit;\n        text-decoration: underline;\n    }\n}\n\n.button{\n    width: 174px!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `Contacts_error__uR0hl`,
	"legalterms": `Contacts_legalterms__9WM03`,
	"button": `Contacts_button__VgYjp`
};
export default ___CSS_LOADER_EXPORT___;
